import styled from 'styled-components';
import { motion } from 'motion/react';
import { media } from '@styles/breakpoints';

export const Wrapper = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing[8]};
  text-align: center;
  background: linear-gradient(
    160deg,
    ${({ theme }) => theme.colors.navy[950]} 0%,
    ${({ theme }) => theme.colors.navy[800]} 100%
  );
  position: relative;
  overflow: hidden;
`;

export const Grid = styled.div`
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
    circle at 1px 1px,
    rgba(255, 255, 255, 0.05) 1px,
    transparent 0
  );
  background-size: 40px 40px;
  pointer-events: none;
`;

export const Glow = styled.div`
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 600px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 168, 240, 0.12) 0%, transparent 70%);
  pointer-events: none;
`;

export const Content = styled(motion.div)`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[6]};
  max-width: 560px;
`;

export const ErrorCode = styled(motion.span)`
  font-size: clamp(6rem, 20vw, 12rem);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.04em;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.navy[400]} 0%,
    ${({ theme }) => theme.colors.steel[500]} 50%,
    ${({ theme }) => theme.colors.cyan[400]} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  user-select: none;

  ${media.tablet} {
    font-size: clamp(8rem, 20vw, 14rem);
  }
`;

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes['2xl']};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: white;

  ${media.tablet} {
    font-size: ${({ theme }) => theme.fontSizes['3xl']};
  }
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.semantic.text.inverseMuted};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
`;

export const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[3]};
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing[2]};
`;
